import { useEffect, useState } from 'react';

declare global {
  interface Window {
    grecaptcha: any;
  }
}

export const useRecaptcha = (siteKey: string | undefined) => {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!siteKey) {
      setError('reCAPTCHA site key no configurado');
      return;
    }

    // Si el script ya está cargado
    if (window.grecaptcha) {
      setIsReady(true);
      return;
    }

    // Cargar script de reCAPTCHA
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      window.grecaptcha.ready(() => {
        setIsReady(true);
      });
    };

    script.onerror = () => {
      setError('Error al cargar reCAPTCHA');
    };

    document.head.appendChild(script);

    return () => {
      // Cleanup: remover script si el componente se desmonta
      const scriptElement = document.querySelector(
        `script[src*="recaptcha"]`
      );
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, [siteKey]);

  const executeRecaptcha = async (action: string = 'submit'): Promise<string | null> => {
    if (!isReady || !siteKey) {
      console.warn('reCAPTCHA no está listo o no configurado');
      return null;
    }

    try {
      const token = await window.grecaptcha.execute(siteKey, { action });
      return token;
    } catch (err) {
      console.error('Error ejecutando reCAPTCHA:', err);
      setError('Error al validar reCAPTCHA');
      return null;
    }
  };

  return { isReady, error, executeRecaptcha };
};
